```vue
<template>
  <div class="pricing-area ptb-100 bg-gondola">
    <div class="container mw-1356">
      <div
        class="section-title mw-860 m-auto text-center"
        data-aos="fade-up"
        data-aos-duration="1000"
        data-aos-delay="100"
      >
        <span class="top-title">الباقات والأسعار</span>
        <h2 class="text-white">اختر الباقة المناسبة لك</h2>
      </div>

      <div class="row justify-content-center">
        <div
          v-for="(plan, index) in pricingPlans"
          :key="index"
          class="col-xl-4 col-md-6"
          :class="{ 'mt-4 mt-xl-0': index !== 0 }"
          data-aos="fade-up"
          data-aos-duration="1000"
          :data-aos-delay="100 * (index + 1)"
        >
          <div class="pricing-single-item style-two">
            <span class="ignite d-block">
              اشتراك IPTV مرن بدون تجديد تلقائي
            </span>

            <div
              class="pricing-content bg-mg"
              :style="{ backgroundImage: 'url(' + plan.bgImage + ')' }"
            >
              <img :src="plan.image" :alt="plan.name + ' pricing'" />

              <div class="amount">
                <span class="months">{{ plan.name }}</span>
                <h2>{{ plan.yearPrice }}€</h2>
                <span class="renew">سنة واحدة</span>
                <h3 class="text-white mt-2">{{ plan.twoYearsPrice }}€ / سنتين</h3>
              </div>

              <ul class="ps-0 list-unstyled pricing-list">
                <li
                  v-for="(feature, i) in plan.features"
                  :key="i"
                  class="d-flex justify-content-between align-items-center"
                >
                  <span>{{ feature.name }}</span>
                  <i
                    class="ti ti-circle-check"
                    :class="{ 'opacity-25': !feature.included }"
                  ></i>
                </li>
              </ul>

              <RouterLink to="/contact-us" class="btn active">
                <span class="border-style">اشترك الآن</span>
              </RouterLink>
            </div>
          </div>
        </div>

        <div class="col-lg-12 text-center mt-4 mt-lg-5">
          <p class="text-silver">
            للمساعدة في اختيار الباقة المناسبة أو تفعيل الاشتراك، تواصل معنا في أي وقت.
            <RouterLink
              to="/contact-us"
              class="read-more style-two text-grey-teal"
            >
              تواصل معنا <i class="ti ti-arrow-right"></i>
            </RouterLink>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";

export default defineComponent({
  name: "PricingPlans",
  setup() {
    const pricingPlans = ref([
      {
        name: "Lite",
        yearPrice: "30",
        twoYearsPrice: "50",
        bgImage: require("@/assets/images/pricing-bg-1.jpg"),
        image: require("@/assets/images/pricing-1.png"),
        features: [
          { name: "قنوات مباشرة مع دليل EPG", included: true },
          { name: "أفلام ومسلسلات VOD", included: true },
          { name: "متوافق مع جميع الأجهزة", included: true },
          { name: "جودة بث مستقرة", included: true },
          { name: "دعم فني", included: true },
        ],
      },
      {
        name: "Ultra",
        yearPrice: "40",
        twoYearsPrice: "60",
        bgImage: require("@/assets/images/pricing-bg-2.jpg"),
        image: require("@/assets/images/pricing-2.png"),
        features: [
          { name: "قنوات مباشرة مع دليل EPG", included: true },
          { name: "أفلام ومسلسلات VOD", included: true },
          { name: "متوافق مع جميع الأجهزة", included: true },
          { name: "تقنية تقليل التقطيع", included: true },
          { name: "أحداث رياضية وPPV", included: true },
        ],
      },
      {
        name: "Pro",
        yearPrice: "45",
        twoYearsPrice: "70",
        bgImage: require("@/assets/images/pricing-bg-3.jpg"),
        image: require("@/assets/images/pricing-3.png"),
        features: [
          { name: "قنوات مباشرة مع دليل EPG", included: true },
          { name: "أفلام ومسلسلات VOD", included: true },
          { name: "متوافق مع جميع الأجهزة", included: true },
          { name: "تقنية تقليل التقطيع", included: true },
          { name: "أفضل جودة ومحتوى رياضي كامل", included: true },
        ],
      },
    ]);

    return { pricingPlans };
  },
});
</script>
```
